module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n    <conciliacionBancaria-consultar></conciliacionBancaria-consultar>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/conciliacionBancaria/conciliacioBancaria-component.html
// module id = ./src/app/Contabilidad/conciliacionBancaria/conciliacioBancaria-component.html
// module chunks = main